import { render } from "./CRMDatatableTaskForm.vue?vue&type=template&id=8cdf7e94&scoped=true"
import script from "./CRMDatatableTaskForm.vue?vue&type=script&lang=js"
export * from "./CRMDatatableTaskForm.vue?vue&type=script&lang=js"

import "./CRMDatatableTaskForm.vue?vue&type=style&index=0&id=8cdf7e94&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cdf7e94"]])

export default __exports__